import "@/components/workspace/workspace.css";
import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/catalog")({
	component: CatalogLayout,
});

function CatalogLayout() {
	return (
		<div
			className="flex h-full overflow-hidden workspace"
			data-density="compact"
		>
			<div className="flex-1 flex flex-col overflow-hidden min-w-0">
				<Outlet />
			</div>
		</div>
	);
}
